import {
  Href,
  RelativePathString,
  router,
  Router,
  useGlobalSearchParams,
  useNavigation,
  useSegments,
} from "expo-router";
import React, { createContext, PropsWithChildren, useEffect, useRef, useState } from "react";
import { Alert, Platform } from "react-native";
import { useModal } from "@/hooks/useModal";
import { EventArg } from "@react-navigation/native";
import { NavGuardModal } from "@/components/Modals/NavGuardModal";

import type { NavigationGuardProviderProps } from "@/types/providers/navigationGuard";

export const NavigationGuardContext = createContext<NavigationGuardProviderProps | undefined>(undefined);

export function NavGuardProvider({ children }: PropsWithChildren) {
  const qs = useGlobalSearchParams();
  const segs = useSegments();

  const { openModal, closeModal, onDismiss } = useModal();
  // const [request, setRequest] = useState<Href>("/");
  const requestRef = useRef<Href>("/");
  const [preventNavigation, setPreventNavigation] = useState<boolean>(false);
  const navigation = useNavigation();
  const [drawerPinned, setDrawerPinned] = useState(false);

  const modal = (
    <NavGuardModal
      onGoBack={closeModal}
      onDiscard={() => {
        setPreventNavigation(false);
        onDismiss(router.push(requestRef.current));
        closeModal();
      }}
    />
  );
  // const push: Router["push"] = (props) => {
  //   if (preventNavigation) {
  //     openModal(modal);
  //     return;
  //   } else {
  //    router.push()
  //   }
  // };
  //

  const createTargetString = (input: string) => {
    return input?.split("-")[0].replace("(", "").replace(")", "").replace("index", "");
  };

  function leafOf(routeLike: any) {
    let r = routeLike;
    while (r?.state?.index != null) r = r.state.routes[r.state.index];
    return r;
  }

  const push: Router["push"] = (props) => {
    if (preventNavigation) {
      return;
    }
    router.push(props);
  };

  // Navigate to an entity, detecting full screen vs panel mode
  const navigateToEntity = (panel: string, id: string) => {
    const isFullScreen = (segs as string[]).includes("[id]");

    if (isFullScreen) {
      router.push(`/${panel}s/${panel}/${id}` as RelativePathString);
    } else {
      router.setParams({ panel, id, tab: "overview", related: "" });
    }
  };

  const tabLongPress = (e: EventArg<"tabLongPress", true, undefined>) => {
    const target = createTargetString(e.target ?? "/");
    if (preventNavigation) {
      e.preventDefault();
      openModal(modal);
    } else {
      router.push(target as Href);
    }
  };

  const tabPress = (e: EventArg<"tabPress", true, undefined>) => {
    const target = createTargetString(e.target ?? "/") as RelativePathString;
    if (preventNavigation) {
      e.preventDefault();
      requestRef.current = ("/" + target) as Href;
      openModal(modal);
    }
    // if (qs.pinned === "true") {
    //   e.preventDefault();
    //   console.log(`shared params from ${segs[2]} to ${target}`);
    //   console.log(`${JSON.stringify(qs)}`);
    //   console.log(qs.pinned);
    //   router.push({ pathname: target, params: qs });
    // }
    // this path prevents previously pinned pages from retriggering the pinned state
    if (drawerPinned) {
      // const state = navigation.getState();
      // const tab = state?.routes.find((r) => r.key === target) ?? target;
      // const leaf = leafOf(tab);
      // const destParams = leaf?.params; // <- what the tab currently has
      // const destName = leaf?.name;
      // const next = Object.fromEntries(Object.entries(qs).filter(([k]) => !["pinned"].includes(k)));
      // router.push({ pathname: target, params: next });
      e.preventDefault();
      router.navigate({ pathname: target, params: qs });
      // console.log(`pinned : true, target: ${target}, params: ${JSON.stringify(qs)}`);
    } else {
      // console.log("normal");
      // console.log(`pinned : true, target: ${target}, params: ${JSON.stringify(qs)}`);
    }
  };

  useEffect(() => {
    const unsubscribe = navigation.addListener("beforeRemove", (e) => {
      e.preventDefault();
      // openModal(modal);
      alert("prevent");
    });
    return unsubscribe;
  }, [navigation]);

  useEffect(() => {
    if (!preventNavigation) return;
    if (Platform.OS === "web") {
      const beforeRemove = navigation.addListener("beforeRemove", (e) => {
        // e.preventDefault();
        // alert("b4remove");
      });

      const handleBeforeUnload = (e: BeforeUnloadEvent) => {
        // alert("b4unload");
        e.preventDefault();
        // e.returnValue = "b4unload"; // triggers browser's default leave prompt
      };

      const handleLocationChange = (e: PopStateEvent) => {
        e.preventDefault();
        // alert("popstate");
      };

      window.addEventListener("beforeUnload", handleBeforeUnload);
      window.addEventListener("beforeRemove", beforeRemove);
      window.addEventListener("popstate", handleLocationChange);
      return () => {
        window.removeEventListener("beforeUnload", handleBeforeUnload);
        window.removeEventListener("beforeRemove", beforeRemove);
        window.removeEventListener("popstate", handleLocationChange);
      };
    } else {
      const listener = navigation.addListener("beforeRemove", (event) => {
        event.preventDefault();
        Alert.alert("Unsaved changes", "You have unsaved changes. Are you sure you want to leave?", [
          { text: "Cancel", style: "cancel" },
          {
            text: "Leave",
            style: "destructive",
            onPress: () => navigation.dispatch(event.data.action),
          },
        ]);
      });

      return listener;
    }
  }, [preventNavigation, navigation]);

  return (
    <NavigationGuardContext.Provider
      value={{
        preventNavigation,
        setPreventNavigation,
        tabPress,
        tabLongPress,
        push,
        drawerPinned,
        setDrawerPinned,
        navigateToEntity,
      }}
    >
      {children}
    </NavigationGuardContext.Provider>
  );
}
